import React from 'react';
import { UI_Modal, UI_Modal_OTP } from "../../UiComponents/index";

function VerifyOTPModal(props) {
    const {
        isOtpSuccess,
        setIsOtpSuccess,
        otp, setOpt,
        handleSubmitOtp,
        handleResendOtp,
        password,
        setPassword,
        inValid
    } = props;
    return (
        <>
            <UI_Modal_OTP
                isOpen={isOtpSuccess}
                closeModal={() => {
                    setIsOtpSuccess(false)
                    localStorage.clear();
                }}
                title="Forgot Password"
            >
                <div className=''>
                    <div className=" pt-[20px] items-start text-white">
                        <div className="basis-1/6 FontFamily-Avenir-reg text-base"><h2>One Time Password</h2></div>
                        <div className="basis-3/4  pt-[15px]">
                            <input
                                type="number"
                                className="w-full  p-1 input_block input_blockFP"
                                value={otp}
                                onChange={(e) => setOpt(e.target.value)}
                                onInput={(e) => {
                                    e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 6)
                                }}
                            />
                        </div>
                        <p className='inValidOtpFP'>{inValid ? inValid : null}</p>
                    </div>
                    <div className="  pt-[20px]  items-start text-white">
                        <div className="basis-1/6  FontFamily-Avenir-reg text-base"><h2>New Password</h2></div>
                        <div className="basis-3/4  pt-[15px]">
                            <input
                                type="password"
                                className="w-full  p-1 input_block"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className=" pt-[20px] flex justify-center items-center FontFamily-Avenir">
                        <button className="cancel_btn_ui text-lg ml-[-10px] mr-[20px]"
                            onClick={handleResendOtp}
                        >Resend Code</button>
                        <button className="submit_btn_ui text-lg"
                            onClick={handleSubmitOtp}
                        >Submit</button>
                    </div>
                </div>
            </UI_Modal_OTP>
        </>
    )
}

export default VerifyOTPModal;